// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uXUS7jSlGDAbbf9AMcqx {
  width: 50vw;
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9000;
  height: fit-content;
}

.vDUZx1gY8BCiHDEoM65s {
  width: 50vw;
  position: relative;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9000;
  height: fit-content;
}

.FnZyNt_TCTF5HOZrICOd {
  font-weight: 700;
  color: darkred;
}

.c4t5MTZhfXtgwTyuczun {
  width: 50vw;
  height: 100vh;
  position: fixed;
  top: 0%;
  left: 0%;
  transform: translateX(-50%);
  gap: 10px;
  z-index: 9001;
}
.c4t5MTZhfXtgwTyuczun .bemb_jUfDV8ntwChJap_ {
  display: flex;
  width: 100%;
  max-height: 60vh;
  overflow: auto;
  padding: 1rem;
  background-color: rgba(241, 245, 249, 0.3019607843);
  border-radius: calc(0.5rem - 2px);
  border: solid 1px #e2e8f0;
}
.c4t5MTZhfXtgwTyuczun .UlN9CfCeBDnv1DZjGgWy {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
}

.o8HaAyYshiFwH11I9IR_ {
  display: none;
}

.vJx3HZmHvq21tQzAWOlI {
  width: 36px !important;
  height: 36px !important;
}

#MOpbGjtOiOkpQRBuaKIj:hover {
  background-color: #f7fafc;
}`, "",{"version":3,"sources":["webpack://./src/componentes/Alerta/AlertaPortal/AlertaPortal.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AACF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AAAA;EACE,gBAAA;EACA,cAAA;AAGF;;AADA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,aAAA;AAIF;AAFE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mDAAA;EACA,iCAAA;EACA,yBAAA;AAIJ;AADE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAGJ;;AAAA;EACE,aAAA;AAGF;;AADA;EACE,sBAAA;EACA,uBAAA;AAIF;;AAFA;EACE,yBAAA;AAKF","sourcesContent":[".alert-container {\r\n  width: 50vw;\r\n  position: fixed;\r\n  top: 0px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  z-index: 9000;\r\n  height: fit-content;\r\n}\r\n.alert-componente {\r\n  width: 50vw;\r\n  position: relative;\r\n  top: 30px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  z-index: 9000;\r\n  height: fit-content;\r\n}\r\n.alert-mensagem {\r\n  font-weight: 700;\r\n  color: darkred;\r\n}\r\n.alert-modal {\r\n  width: 50vw;\r\n  height: 100vh;\r\n  position: fixed;\r\n  top: 0%;\r\n  left: 0%;\r\n  transform: translateX(-50%);\r\n  gap: 10px;\r\n  z-index: 9001;\r\n\r\n  .alert-modal-corpo {\r\n    display: flex;\r\n    width: 100%;\r\n    max-height: 60vh;\r\n    overflow: auto;\r\n    padding: 1rem;\r\n    background-color: #f1f5f94d;\r\n    border-radius: calc(0.5rem - 2px);\r\n    border: solid 1px #e2e8f0;\r\n  }\r\n\r\n  .alert-modal-footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 24px;\r\n  }\r\n}\r\n.alert-modal-hidden {\r\n  display: none;\r\n}\r\n.icon {\r\n  width: 36px !important;\r\n  height: 36px !important;\r\n}\r\n#fecharBotao:hover {\r\n  background-color: #f7fafc;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
var _1 = `uXUS7jSlGDAbbf9AMcqx`;
export { _1 as "alert-container" };
var _2 = `vDUZx1gY8BCiHDEoM65s`;
export { _2 as "alert-componente" };
var _3 = `FnZyNt_TCTF5HOZrICOd`;
export { _3 as "alert-mensagem" };
var _4 = `c4t5MTZhfXtgwTyuczun`;
export { _4 as "alert-modal" };
var _5 = `bemb_jUfDV8ntwChJap_`;
export { _5 as "alert-modal-corpo" };
var _6 = `UlN9CfCeBDnv1DZjGgWy`;
export { _6 as "alert-modal-footer" };
var _7 = `o8HaAyYshiFwH11I9IR_`;
export { _7 as "alert-modal-hidden" };
export var icon = `vJx3HZmHvq21tQzAWOlI`;
export var fecharBotao = `MOpbGjtOiOkpQRBuaKIj`;
export default ___CSS_LOADER_EXPORT___;
